import React, { useEffect } from 'react'
import "../styles/services.css";
import {FaFigma, FaReact } from 'react-icons/fa';
import { SiFlutter } from 'react-icons/si';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Services = () => {
      useEffect(() =>{
        Aos.init({
        duration: 1000, 
        easing: 'ease-in-out', 
        once: false,  
        offset: 100, 
        });
      }, [])


  return (
    <div id='services'>
      <h1 data-aos ='fade-up'>My Expertise</h1>
      <p data-aos ='fade-up'>Expertise that bring your vision to life</p>
      <div className='services'>
        <div className='service' data-aos="fade-up">
          <FaReact className='icon'/>
          <div className='service-head'>Web
            <span> Development</span>

          </div>
          <p>I build mobile responsive and interactive website using a variety of frameworks and tools.</p>
        </div>

        <div className='service' data-aos="fade-up">
          <FaFigma className='icon'/>
          <div className='service-head'>UI/UX
             <span> Design</span>

          </div>
          <p>Ensuring very solution is visually appealing, intuitive, and optimized for user satisfaction.</p>
        </div>

        <div className='service' data-aos="fade-up">
           <SiFlutter className='icon'/>
          <div className='service-head'>Mobile 
            <span> Development</span>

          </div>
          <p>Skilled in developing hybrid mobile apps and cross-platform solutions using the modern framework.</p>
        </div>

      </div>
    </div>
  )
}

export default Services